// 客户费率模板

import { HttpProductManageList, HttpExportProductManage, HttpPushProductManage } from '@/service/setting';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import compDetail from './detail';
import mixin from './mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        compDetail
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            formData: {
                search: {
                    EQ_enable: null
                }
            }
        };
    },
    methods: {
        ajaxRequest: HttpProductManageList,
        handleOperates(params, type, batch) {
            if (batch === true) {
                params = params || this.checkedData;
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: "请选择至少一条数据" }));
            }
            switch (type) {
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: "查看" }),
                        show: true,
                        width: 'large',
                        component: "compDetail",
                        showFooter: false,
                        params
                    }
                    break;
                case 'push':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: {
                            skus: params
                        },
                        title: this.$t('fbb.common.push_warehouse', { defaultValue: "推送仓库" }),
                        ajaxRequest: HttpPushProductManage
                    }
                    break;
                case 'export':
                    this.handleWebfs(HttpExportProductManage, this.formData, { executor: 'request', download: true });
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: "查看" }),
                show: true,
                params: id,
                operate: 'query'
            }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusproductList', 'getBillcusWareList']),
        ToolsData() {
            return [{
                name: this.$t('fbb.common.push_warehouse', { defaultValue: "推送仓库" }),
                operate: "push",
                theme: "primary",
                batch: true,
            }, 
            // {
            //     name: this.$t('global.common.export', { defaultValue: "导出" }),
            //     operate: "export",
            // },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.cusorg', { defaultValue: "客户组织" }),
                    key: 'EQ_orgId',
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    },
                    show: true,
                },
                {
                    label: this.$t('global.common.sku', { defaultValue: "SKU" }),
                    key: 'EQ_erpSku',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                    show: true,
                },
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: 'EQ_enable',
                    tag: 'vSelect',
                    options: this.getProductStatus.slice(1),
                },
                {
                    label: this.$t('fbb.setting.goods_type', { defaultValue: "产品类型" }),
                    key: 'EQ_productType',
                    tag: 'vSelect',
                    options: this.getProductType,
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    formName: 'erpSku',
                    width: 60,
                },
                {
                    title: this.$t('global.common.actions', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                }, {
                    title: this.$t('global.common.cusorg', { defaultValue: "客户组织" }),
                    key: 'orgName',
                }, {
                    title: this.$t('global.common.sku', { defaultValue: "SKU" }),
                    key: 'erpSku',
                    render: (h, { row }) => {
                        return <a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.erpSku}</a>
                    }
                }, {
                    title: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'lineId',
                    render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId),
                }, {
                    title: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: 'enable',
                    render: (h, { row }) => this.findRenderLabel(this.getProductStatus, row.enable),
                }, {
                    title: this.$t('fbb.setting.goods_nameEn', { defaultValue: "品名(英文)" }),
                    key: 'nameEn',
                }, {
                    title: this.$t('fbb.setting.goods_size', { defaultValue: "单品包装尺寸(inch)" }),
                    key: 'itemLength',
                    render(h, { row }) {
                        return `${row.itemLength}*${row.itemWidth}*${row.itemHeight}`
                    }
                }, {
                    title: this.$t('fbb.setting.goods_weight', { defaultValue: "毛重(lb)" }),
                    key: 'weight',
                }, {
                    title: this.$t('global.common.cost', { defaultValue: "FOB（美元）" }),
                    key: 'cost',
                }, {
                    title: this.$t('fbb.setting.inventory', { defaultValue: "库存量" }),
                    key: 'inventory',
                }, {
                    title: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    key: 'updatedAt',
                }];
        },
    },
};




